module.exports = __webpack_public_path__ + "static/img/dingwei.1db0bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/dingwei.png
// module id = cvJb
// module chunks = 19